/* eslint-disable react-hooks/exhaustive-deps */

import { useLocation } from "react-router-dom";
import { LoadingIcon } from "utils/constant";
import SingleAccusedForRegional from "./SingleAccusedForRegional";
import SingleAccusedForZonal from "./SingleAccusedForZonal";

export default function SingleAccused() {
  const { state } = useLocation();

  if (!state)
    return (
      <div className="flex justify-center items-center h-96">{LoadingIcon}</div>
    );

  return state?.is_regional ? (
    <SingleAccusedForRegional />
  ) : (
    <SingleAccusedForZonal />
  );
}
